const Spinner = (props: any) => {
  <div {...props} />;
};

export default Spinner;
